import http from '@/axios/http'
import { getuser_id, getclient_user_id, getgroup, getuser_iscustomer, getuser_ctid } from "@/localStorage/localStorage";

//设备列表
export function getDeviceList(offset, limit) {
    const data = {
        user_id: getuser_id(),
        offset: offset,
        limit: limit
    }
    return http({
        url: '/api/device/getDeviceList',
        method: 'post',
        data
    })
}

//删除设备
export function deleteDevice(device_id) {
    const data = {
        user_id: getuser_id(),
        device_id: device_id
    }
    return http({
        url: '/api/device/deleteDevice',
        method: 'post',
        data
    })
}

//设备查询
export function queryKeyword(offset = 1, limit = 10, keyword, sort, gid) {
    const data = {
        user_id: getuser_id(),
        keyword: keyword,
        offset: offset,
        limit: limit,
        ...sort,
        gid: gid
    }
    return http({
        url: '/api/device/queryKeyword',
        method: 'post',
        data
    })
}

//获取三级分组
export function getAddLevel3Group(pid) {
    return http({
        url: '/api/device/getAddLevelGroup',
        method: 'post',
        data: { pid }
    })
}

//修改设备分组
export function changeDeviceGroup(needChangeDevices, groupId) {
    const data = {
        userId: getuser_id(),
        needChangeDevices: needChangeDevices,
        groupId: groupId
    }
    return http({
        url: '/api/device/changeDeviceGroup',
        method: 'post',
        data
    })
}
//操作设备
export function operateDevice(did, type, time = '', week = '', serial = '') {
    const data = {
        did: did,
        type: type,
        week: week,
        time: time,
        sm: '1',
        serial: serial
    }
    return http({
        url: '/api/device/operateDevice',
        method: 'post',
        data
    })
}

//关闭代理
export function closeRemote(did) {
    const data = {
        did: did
    }
    return http({
        url: '/api/device/closeRemote',
        method: 'post',
        data
    })
}

//获取设备日志
export function findDeviceLog(did) {
    const data = {
        did: did
    }
    return http({
        url: '/api/logManager/findDeviceLog',
        method: 'post',
        data
    })
}

//获取设备配置
export function findDeviceConfiguration(did) {
    const data = {
        did: did
    }
    return http({
        url: '/api/configurationFileManager/findDeviceConfiguration',
        method: 'post',
        data
    })
}
//下载备份的配置文件
export function configurationFileManagerdownload(downloadUrl, realFileName) {
    return http({
        url: `/api/configurationFileManager/findDeviceConfiguration?downloadUrl=${downloadUrl}&realFileName=${realFileName}`,
        method: 'get',
        responseType: 'blob'
    })
}
//下载设备日志
export function logManagerdownload(downloadUrl, realFileName) {
    return http({
        url: `/api/logManager/download?downloadUrl=${downloadUrl}&realFileName=${realFileName}`,
        method: 'get',
        responseType: 'blob'
    })
}
//修改设备名称与设备位置
export function updateDevice(id, deviceName, deviceAddress) {
    const data = {
        id: id,
        deviceName: deviceName,
        deviceAddress: deviceAddress
    }
    return http({
        url: '/api/device/updateDevice',
        method: 'post',
        data
    })
}

// 修复设备
export function repairDevice(dsn) {
    return http({
        url: `/api/clients/${dsn}/sendSms`,
        method: 'get',
    })
}

// 修复全部设备
export function repairAllDevice() {
    return http({
        url: `/api/start-device-task`,
        method: 'get',
    })
}

// 查看修复进度
export function repairProgress(taskId) {
    return http({
        url: `/api/task-status/${taskId}`,
        method: 'get',
    })
}